import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d9rhnp7nahb7382ovmq0';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setSubmitted(true);
      setEmail('');
      return;
    }

    if (!email.trim()) {
      setError('请输入您的邮箱地址');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: email.trim() }).toString(),
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch (_err) { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setSubmitted(true);
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        setError(serverMsg || '提交失败，请稍后再试');
      }
    } catch (_err) {
      setError('网络错误，请检查连接后重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-16 md:py-24 bg-accent-500 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-background-50 rounded-full -translate-y-1/2 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-background-50 rounded-full translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开始你的创作之旅了吗？
        </h2>
        <p className="text-accent-100 text-sm md:text-base mb-8 leading-relaxed">
          免费注册 luluca，加入全球500万创作者社区，开启你的智能创作体验
        </p>

        {submitted ? (
          <div className="bg-background-50/15 backdrop-blur-sm rounded-2xl p-6 inline-block">
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-background-50/20 text-background-50 mb-3">
              <i className="ri-check-line text-2xl"></i>
            </div>
            <p className="text-background-50 font-semibold">
              订阅成功！感谢你的关注
            </p>
          </div>
        ) : (
          <form
            data-readdy-form="true"
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              className="w-full sm:flex-1 px-5 py-3.5 rounded-full bg-background-50 text-foreground-900 text-sm placeholder:text-foreground-400 outline-none focus:ring-2 focus:ring-background-300"
              required
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-foreground-800 transition-colors disabled:opacity-60 cursor-pointer"
            >
              {loading ? '提交中...' : '免费订阅'}
            </button>
          </form>
        )}
        {error && (
          <p className="mt-3 text-sm text-red-200">{error}</p>
        )}
      </div>
    </section>
  );
}